import * as React from 'react';
import { useIntl } from 'react-intl';

import * as Styled from './discover-badge.styles';
import type { DiscoverBadgeProps } from './discover-badge.types';
import { useStopPulseAnimationListener } from './use-stop-pulse-animation-listener';

export const DiscoverBadge = React.forwardRef<
  HTMLSpanElement,
  DiscoverBadgeProps
>(({ className, role = 'status', ...props }, forwardedRef) => {
  const intl = useIntl();
  const badgeRef = React.useRef<HTMLSpanElement>();
  React.useImperativeHandle(forwardedRef, () => badgeRef.current!);
  const stopPulseAnimation = useStopPulseAnimationListener(badgeRef);

  return (
    <Styled.DiscoverBadge
      aria-label={intl.formatMessage({
        id: 'XDS_DISCOVER_BADGE_A11Y',
        defaultMessage: 'New feature',
      })}
      aria-live="polite"
      className={className}
      data-xds="DiscoverBadge"
      ref={badgeRef}
      role={role}
      $stopPulseAnimation={stopPulseAnimation}
      {...props}
    />
  );
});

DiscoverBadge.displayName = 'DiscoverBadge';
